import { getLocale } from '@/ui/i18n/i18n';
// pure defers load of stripe
// see official stripe blog https://dev.to/stripe/importing-stripe-js-as-an-es-module-1ni
import { loadStripe } from '@stripe/stripe-js/pure';
import { ref } from 'vue';
import { isContactingStripe } from '@/ui/subscription/subscription';

const stripe = ref();
const cardNumber = ref();
const cardExpiry = ref();
const cardCvc = ref();

const getStripe = async () => {
  if (!stripe.value) {
    await initStripe();
  }

  return stripe.value;
};

const initStripe = async () => {
  stripe.value = await loadStripe(`${process.env.VUE_APP_STRIPE_PK}`);
  const elements = stripe.value.elements({ locale: getLocale() });
  const elementStyles = {
    base: {
      color: '#32325D',
      fontWeight: 500,
      fontFamily: 'Barlow, system-ui, BlinkMacSystemFont, -apple-system, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',

      '::placeholder': {
        color: '#CFD7DF',
      },
      ':-webkit-autofill': {
        color: '#e39f48',
      },
    },
    invalid: {
      color: '#E25950',

      '::placeholder': {
        color: '#FFCCA5',
      },
    },
  };

  const elementClasses = {
    focus: 'focus',
    empty: 'empty',
    invalid: 'invalid',
  };

  cardNumber.value = elements.create('cardNumber', {
    style: elementStyles,
    classes: elementClasses,
  });
  cardExpiry.value = elements.create('cardExpiry', {
    style: elementStyles,
    classes: elementClasses,
  });
  cardCvc.value = elements.create('cardCvc', {
    style: elementStyles,
    classes: elementClasses,
  });
};

//we do not do global load in html anymore
//const stripe = await loadStripe(`${process.env.VUE_APP_STRIPE_PK}`);

async function createPaymentMethod({
  name, email, address, city, zip, country,
}) {
  return stripe.value.createPaymentMethod(
    'card',
    cardNumber.value, {
      billing_details: {
        name,
        email,
        address: {
          line1: address,
          city,
          postal_code: zip,
          country,
        },
      },
    },
  );
}

async function confirmCardSetup(clientSecret, attributes) {
  isContactingStripe.value = true;
  const response = await stripe.value.confirmCardSetup(clientSecret, attributes);
  isContactingStripe.value = false;

  return response;
}

async function confirmCardPayment(clientSecret, attributes) {
  isContactingStripe.value = true;
  const response = await stripe.value.confirmCardPayment(clientSecret, attributes);
  isContactingStripe.value = false;

  return response;
}

export {
  getStripe,
  cardNumber,
  cardExpiry,
  cardCvc,
  createPaymentMethod,
  confirmCardSetup,
  confirmCardPayment,
};
